/*! Copyright (c) Safe As Milk. All rights reserved. */
class BackToTopButton extends HTMLElement {
    constructor() {
        super();
        this._ticking = false;
        this._visible = null;
        this.toggleVisibility = this.toggleVisibility.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
    }
    connectedCallback() {
        window.addEventListener("scroll", this.onScroll, {
            passive: true
        });
        window.addEventListener("resize", this.onScroll, {
            passive: true
        });
        window.addEventListener("touchmove", this.onScroll, {
            passive: true
        });
        this.addEventListener("click", this.scrollToTop);
        this.toggleVisibility();
    }
    disconnectedCallback() {
        window.removeEventListener("scroll", this.onScroll);
        window.removeEventListener("resize", this.onScroll);
        window.removeEventListener("touchmove", this.onScroll);
        this.removeEventListener("click", this.scrollToTop);
    }
    onScroll() {
        if (this._ticking) return;
        this._ticking = true;
        requestAnimationFrame(() => {
            this._ticking = false;
            this.toggleVisibility();
        });
    }
    toggleVisibility() {
        const {scrollY: scrollY} = window;
        const {innerHeight: innerHeight} = window;
        const isScrolledPastViewport = scrollY > innerHeight;
        if (isScrolledPastViewport === this._visible) return;
        this._visible = isScrolledPastViewport;
        if (isScrolledPastViewport) {
            this.classList.add("visible");
            this.classList.remove("hidden");
        } else {
            this.classList.remove("visible");
            this.classList.add("hidden");
        }
    }
    scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth"
        });
        this.dispatchEvent(new CustomEvent("on:back-to-top-button:clicked"));
    }
}

customElements.define("back-to-top-button", BackToTopButton);
//# sourceMappingURL=back-to-top-button.js.map
